import { AxiosInstance } from 'axios';
import client from './client';
import setupInterceptorsTo from './interceptors/authorizationInterceptor';

export const clientWithAuth: AxiosInstance = setupInterceptorsTo(client);
export const clientWithoutAuth = client;
